HTTP_STATUS = {
  UNAUTHORIZED: 401
  FORBIDDEN: 403
}

module.exports = HTTP_STATUS